import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { StyleSheet, Text } from "react-native"

export const OpenSansText = (props) => {
    const fontFamily = props.defaultFontFamily
        ? props.defaultFontFamily
        : props.fontWeight === "bold"
        ? "OpenSansBold"
        : props.fontStyle === "Regular"
        ? "OpenSansRegular"
        : props.fontStyle === "italic"
        ? "OpenSansItalic"
        : "OpenSans"

    return (
        <Text
            numberOfLines={props.numberOfLines ?? undefined}
            style={[
                styles.text,
                {
                    textAlign: props.textAlign,
                    fontWeight: props.fontWeight,
                    fontSize: props.fontSize,
                    color: props.color || baseColors.black,
                    fontFamily: fontFamily,
                    ...props.style
                }
            ]}
            onPress={props.onPress ?? undefined}
        >
            {props.children}
        </Text>
    )
}

const styles = StyleSheet.create({
    text: {
        color: baseColors.black
    }
})
